import { Directive, ElementRef, EventEmitter, Output, OnInit, OnDestroy, HostListener, Injectable } from '@angular/core';
import { NgControl } from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs';
import { of } from 'rxjs';
import { debounceTime, distinctUntilChanged, skip, switchMap } from 'rxjs/operators';
import { AuthService } from '../../services/auth.service';
import { PostcodeList, SuburbList } from '../../models/account-delivery-address';
import { CheckOutService } from '../../services/checkout.service';

@Directive({
    selector: '[postcode]'
})
@Injectable()
export class PostCodeDirective implements OnInit, OnDestroy {

    constructor(
        private checkOutService: CheckOutService, 
        private authService: AuthService,
        private _el: ElementRef,
        private ngControl: NgControl
        ) { }



    postcode$: Subject<string> = new Subject<string>();

    subscription: Subscription = {} as Subscription;

    //@Output('postcode') postcodes: EventEmitter<SuburbList[]> = new EventEmitter<SuburbList[]>();

    @Output('postcode') postcodes: EventEmitter<PostcodeList[]> = new EventEmitter<PostcodeList[]>();

    @HostListener('input', ['$event']) onInputChange(event: any) {
        const initalValue = this._el.nativeElement.value;
        this._el.nativeElement.value = initalValue.replace(/[^0-9]*/g, '');
        if (initalValue !== this._el.nativeElement.value) {
            event.stopPropagation();
        } else {
            this.postcode$.next(this._el.nativeElement.value);
        }
    }

    ngOnInit() {
        this.subscription = this.postcode$.pipe(
            debounceTime(500),
            distinctUntilChanged(),
            switchMap((e: string) => {
                if (e.length >= 4) {
                    //return this.checkOutService.getPostCodeList(e);            
                    return this.authService.GetPostCodeList('', e);
                } else {
                    return of([]);
                }
            })).subscribe((res) => {
                this.postcodes.emit(res);
            });
    }

    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

}